var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 15.9996C27.9998 16.2648 27.8945 16.5192 27.7069 16.7067C27.5194 16.8942 27.265 16.9996 26.9998 16.9996H7.41356L14.7073 24.2921C14.8002 24.385 14.8739 24.4953 14.9242 24.6167C14.9745 24.7381 15.0004 24.8682 15.0004 24.9996C15.0004 25.131 14.9745 25.2611 14.9242 25.3825C14.8739 25.5039 14.8002 25.6142 14.7073 25.7071C14.6144 25.8 14.5041 25.8737 14.3827 25.924C14.2613 25.9743 14.1312 26.0001 13.9998 26.0001C13.8684 26.0001 13.7383 25.9743 13.6169 25.924C13.4955 25.8737 13.3852 25.8 13.2923 25.7071L4.29231 16.7071C4.19933 16.6142 4.12557 16.5039 4.07525 16.3825C4.02493 16.2611 3.99902 16.131 3.99902 15.9996C3.99902 15.8682 4.02493 15.738 4.07525 15.6166C4.12557 15.4952 4.19933 15.385 4.29231 15.2921L13.2923 6.29208C13.4799 6.10444 13.7344 5.99902 13.9998 5.99902C14.2652 5.99902 14.5197 6.10444 14.7073 6.29208C14.895 6.47972 15.0004 6.73422 15.0004 6.99958C15.0004 7.26494 14.895 7.51944 14.7073 7.70708L7.41356 14.9996H26.9998C27.265 14.9996 27.5194 15.1049 27.7069 15.2925C27.8945 15.48 27.9998 15.7344 27.9998 15.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.8dd13746f75cab4efce59ee0d8b1786b.svg";
export { ForwardRef as ReactComponent };